import React,{useState} from "react";
import Calendarview from "../Campus/Calenderview";

const ParentCorner = () => {
    const circularsData = [
        { id: 1, title: 'Circular #25/24 - 22 May 2023', isNew: true },
        { id: 2, title: 'Circular #24/24 - 15 May 2023', isNew: false },
        { id: 3, title: 'Circular #23/24 - 8 May 2023', isNew: false },
        { id: 4, title: 'Circular #22/24 - 1 May 2023', isNew: false },
        { id: 5, title: 'Circular #21/24 - 24 Apr 2023', isNew: false },
        { id: 6, title: 'Circular #20/24 - 17 Apr 2023', isNew: false },
        { id: 7, title: 'Circular #19/24 - 10 Apr 2023', isNew: false },
        { id: 8, title: 'Circular #18/24 - 3 Apr 2023', isNew: false },
        { id: 9, title: 'Circular #17/24 - 27 Mar 2023', isNew: false },
        { id: 10, title: 'Circular #16/24 - 20 Mar 2023', isNew: false },
        { id: 11, title: 'Circular #15/24 - 13 Mar 2023', isNew: false },
        { id: 12, title: 'Circular #14/24 - 6 Mar 2023', isNew: false },
        { id: 13, title: 'Circular #13/24 - 27 Feb 2023', isNew: false },
        { id: 14, title: 'Circular #12/24 - 20 Feb 2023', isNew: false },
        { id: 15, title: 'Circular #11/24 - 13 Feb 2023', isNew: false },
        { id: 16, title: 'Circular #10/24 - 6 Feb 2023', isNew: false },
        { id: 17, title: 'Circular #09/24 - 30 Jan 2023', isNew: false },
        { id: 18, title: 'Circular #08/24 - 23 Jan 2023', isNew: false },
        { id: 19, title: 'Circular #07/24 - 16 Jan 2023', isNew: false },
        { id: 20, title: 'Circular #06/24 - 9 Jan 2023', isNew: false },
        { id: 21, title: 'Circular #05/24 - 2 Jan 2023', isNew: false },
        { id: 22, title: 'Circular #04/24 - 26 Dec 2022', isNew: false },
        { id: 23, title: 'Circular #03/24 - 19 Dec 2022', isNew: false },
        { id: 24, title: 'Circular #02/24 - 12 Dec 2022', isNew: false },
        { id: 25, title: 'Circular #01/24 - 5 Dec 2022', isNew: false }
      ];
    
      // Pagination state
      const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 10;
    
      // Calculate total pages
      const totalPages = Math.ceil(circularsData.length / itemsPerPage);
    
      // Get current circulars
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentCirculars = circularsData.slice(indexOfFirstItem, indexOfLastItem);
    
      // Change page
      const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
      // Previous page
      const prevPage = () => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      // Next page
      const nextPage = () => {
        if (currentPage < totalPages) {
          setCurrentPage(currentPage + 1);
        }
      };
      const downloadItems = [
        {
          id: 1,
          icon: 'bi-file-earmark-text',
          title: 'Book List 2023-24',
          buttonText: 'Download PDF',
          fileSize: '2.4 MB'
        },
        {
          id: 2,
          icon: 'bi-person-bounding-box',
          title: 'Uniform Policy',
          buttonText: 'Download PDF',
          fileSize: '1.8 MB'
        },
        {
          id: 3,
          icon: 'bi-calendar-event',
          title: 'School Timings',
          buttonText: 'Download PDF',
          fileSize: '1.2 MB'
        },
        {
            id: 4,
            icon: 'bi-file-earmark-text',
            title: 'Academic calender 2023-24',
            buttonText: 'Download PDF',
            fileSize: '2.4 MB'
          },
          {
            id: 5,
            icon: 'bi-person-bounding-box',
            title: 'School Bus Routes',
            buttonText: 'Download PDF',
            fileSize: '1.8 MB'
          },
          {
            id: 6,
            icon: 'bi-calendar-event',
            title: 'Parents HandBook',
            buttonText: 'Download PDF',
            fileSize: '1.2 MB'
          }
      ];
    

  return (
    <>
    <section className="Subpage_Hero">
      <div className="container">
        <div className="text-lg-start text-center" data-aos="fade-up">
          <h1>Our Parent Corner</h1>
          <p>
          This page must stand out with icons, infographics, student videos, and success stories. 

          </p>
        </div>
      </div>
    </section>

    <div className="parent-corner-page container py-5">


      {/* Academic Calendar */}

        {/* Calendar Header */}
        <Calendarview />

      {/* Weekly Circulars */}
      <section className="mb-5" >
  <h2 className="h2 display-5 fw-bold text-center mb-4">Weekly Circulars</h2>

  <div className="card border-0 shadow-sm" data-aos="fade-in-right" data-aos-delay="300" data-aos-durations="1000">
    <div className="card-body p-0">
      {/* Desktop Table (visible on md and up) */}
      <div className="d-none d-md-block">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="bg-light">
              <tr>
                <th className="ps-4" style={{width: '0%'}}>
                  <div className="form-check"></div>
                </th>
                <th style={{width: '15%'}}>Circular No.</th>
                <th style={{width: '45%'}}>Title</th>
                <th style={{width: '20%'}} className="text-center">Date</th>
                <th style={{width: '20%'}} className="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {currentCirculars.map((circular) => {
                const [title, date] = circular.title.split(' - ');
                const isNew = circular.isNew;
                const isUrgent = circular.id % 5 === 0;

                return (
                  <tr key={circular.id} className="position-relative">
                    <td className="ps-4">
                      <div className="form-check"></div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className={`icon-shape icon-sm rounded-circle me-3
                          ${isUrgent ? 'bg-danger text-white' : 'bg-success bg-opacity-10 text-success'}`}>
                          <i className={`bi ${isUrgent ? 'bi-exclamation-lg' : 'bi-file-earmark-text'}`}></i>
                        </div>
                        <span className="fw-bold">#{circular.id}</span>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex flex-column">
                        <span className="fw-semibold text-dark">{title}</span>
                      </div>
                    </td>
                    <td className="text-center">
                      <div className="badge bg-light text-dark">
                        <i className="bi bi-calendar me-1"></i>
                        {date}
                      </div>
                    </td>
                    <td className="text-center" style={{cursor:"pointer"}}>
                      <span className={`badge ${isNew ? 'bg-primary bg-opacity-10 text-white' : 'bg-secondary bg-opacity-10 text-white'}`}>
                        {isNew ? (
                          <>
                            <i className="bi bi-star-fill me-1"></i> New
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check-circle me-1"> </i> Viewed
                          </>
                        )}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Cards (visible on sm and down) */}
      <div className="d-md-none">
        <div className="list-group list-group-flush">
          {currentCirculars.map((circular) => {
            const [title, date] = circular.title.split(' - ');
            const isNew = circular.isNew;
            const isUrgent = circular.id % 5 === 0;

            return (
              <div key={circular.id} className="list-group-item p-3 border-bottom">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div className="d-flex align-items-center">
                    <div className={`icon-shape icon-sm rounded-circle me-3
                      ${isUrgent ? 'bg-danger text-white' : 'bg-success bg-opacity-10 text-success'}`}>
                      <i className={`bi ${isUrgent ? 'bi-exclamation-lg' : 'bi-file-earmark-text'}`}></i>
                    </div>
                    <span className="fw-bold">#{circular.id}</span>
                  </div>
                  <span className={`badge ${isNew ? 'bg-primary bg-opacity-10 text-white' : 'bg-secondary bg-opacity-10 text-white'}`}>
                    {isNew ? 'New' : 'Viewed'}
                  </span>
                </div>
                
                <h6 className="fw-semibold mb-2">{title}</h6>
                
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-muted">
                    <i className="bi bi-calendar me-1"></i>
                    {date}
                  </small>
                  <button className="btn btn-sm btn-outline-primary">View</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Pagination (common for both views) */}
      <div className="card-footer bg-white border-top">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="mb-2 mb-md-0">
            <span className="text-muted small">
              Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, circularsData.length)} of {circularsData.length}
            </span>
          </div>
          
          <nav aria-label="Page navigation">
            <ul className="pagination pagination-sm mb-0">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={prevPage}>
                  <i className="bi bi-chevron-left"></i>
                </button>
              </li>

              {currentPage > 3 && (
                <li className="page-item d-none d-md-block">
                  <button className="page-link" onClick={() => paginate(1)}>1</button>
                </li>
              )}
              {currentPage > 4 && (
                <li className="page-item disabled d-none d-md-block">
                  <span className="page-link">...</span>
                </li>
              )}

              {[
                currentPage - 2,
                currentPage - 1,
                currentPage,
                currentPage + 1,
                currentPage + 2
              ].map((page) => (
                page > 0 && page <= totalPages && (
                  <li key={page} className={`page-item ${currentPage === page ? 'active' : ''} ${Math.abs(currentPage - page) > 2 ? 'd-none d-md-block' : ''}`}>
                    <button className="page-link" onClick={() => paginate(page)}>
                      {page}
                    </button>
                  </li>
                )
              ))}

              {currentPage < totalPages - 3 && (
                <li className="page-item disabled d-none d-md-block">
                  <span className="page-link">...</span>
                </li>
              )}
              {currentPage < totalPages - 2 && (
                <li className="page-item d-none d-md-block">
                  <button className="page-link" onClick={() => paginate(totalPages)}>
                    {totalPages}
                  </button>
                </li>
              )}

              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button className="page-link" onClick={nextPage}>
                  <i className="bi bi-chevron-right"></i>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</section>


      {/* PTM Dates & Updates */}
      <section className="mb-5">
      <h2 className="h2  display-5 fw-bold text-center">PTM Dates & Updates</h2>

  <div className="card shadow-sm border-0 h-100" style={{ minHeight: '500px' }} data-aos="fade-in-left" data-aos-delay="300" data-aos-durations="1000">
    <div className="card-header bgcolor1 mb-0 text-white d-flex justify-content-between align-items-center">
      <h2 className="h5 mb-0 d-flex align-items-center">
        {/* <i className="bi bi-calendar-event me-2"></i> */}
        PTM Dates
      </h2>
      <span className="badge bg-white text-info">Academic Year 2023-24</span>
    </div>
    
    <div className="card-body">
      {/* Next PTM Alert */}
      <div className="alert alert-warning d-flex align-items-center">
        {/* <i className="bi bi-exclamation-triangle-fill me-2 fs-4"></i> */}
        <div>
          <strong>Next PTM:</strong> 25th May 2023 (Thursday), 9:00 AM - 12:00 PM<br /><br />
          <small className="text-muted">Venue: School Auditorium | Last booking date: 23rd May</small>
        </div>
      </div>
      
      {/* PTM Content */}
      <div className="row g-3 h-100">
        {/* Upcoming PTMs Column */}
        <div className="col-md-6 d-flex flex-column">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">Upcoming PTMs</h5>
            <button className="btn btn-sm btn-outline-info">
              <i className="bi bi-plus"></i> Add to Calendar
            </button>
          </div>
          
          <div className="list-group list-group-flush flex-grow-1 overflow-auto" style={{ maxHeight: '250px' }}>
            {[
              { id: 1, date: '25 May 2023', status: 'Slot Booking Open', slots: '32/50 slots available' },
              { id: 2, date: '15 July 2023', status: 'Coming Soon', note: 'Schedule will be announced' },
              { id: 3, date: '10 September 2023', status: 'Planning', note: 'Tentative date' },
              { id: 4, date: '12 November 2023', status: 'Planning', note: 'Tentative date' }
            ].map((ptm) => (
              <div key={ptm.id} className="list-group-item py-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="fw-semibold mb-1">{ptm.date}</div>
                    {ptm.note && <small className="text-muted ">{ptm.note}</small>}
                    {ptm.slots && <small className="text-muted d-block">{ptm.slots}</small>}
                  </div>
                  <span className={`badge ${
                    ptm.status === 'Slot Booking Open' ? 'bg-warning text-dark' : 
                    ptm.status === 'Coming Soon' ? 'bg-info text-white' : 'bg-light text-dark'
                  }`}>
                    {ptm.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Previous PTMs Column */}
        <div className="col-md-6 d-flex flex-column">
          <h5 className="mb-2">Previous PTM Reports</h5>
          
          <div className="list-group list-group-flush flex-grow-1 overflow-auto" style={{ maxHeight: '250px' }}>
            {[
              { id: 1, title: 'March 2023 PTM Summary', date: '15 Mar 2023', downloads: 142 },
              { id: 2, title: 'January 2023 PTM Summary', date: '10 Jan 2023', downloads: 98 },
              { id: 3, title: 'November 2022 PTM Minutes', date: '20 Nov 2022', downloads: 75 },
              { id: 4, title: 'September 2022 PTM Feedback', date: '12 Sep 2022', downloads: 63 }
            ].map((report) => (
              <div key={report.id} className="list-group-item py-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <a href="#" className="text-decoration-none color">
                      <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                      {report.title}
                    </a>
                    <small className="text-muted d-block">{report.date}</small>
                  </div>
                  <div className="text-end">
                    <small className="text-muted d-block">
                      <i className="bi bi-download"></i> {report.downloads}
                    </small>
                    <small>
                      <a href="#" className="text-decoration-none">View Details</a>
                    </small>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-auto pt-3">
            <button className="btn btn-sm btn-outline-secondary w-100">
              <i className="bi bi-archive"></i> View All Past PTM Records
            </button>
          </div>
        </div>
      </div>
    </div>
    
    {/* Card Footer */}
    <div className="card-footer bg-transparent border-top text-center py-2 mb-2">
      <small className="text-muted">
        <i className="bi bi-info-circle fw-semibold"></i> PTM timings: 9:00 AM - 12:00 PM | Duration: 15 mins per parent
      </small>
    </div>
  </div>
    </section>

      {/* Parent Feedback Form */}
      <section className="mb-5" >
      <h2 className="h2  display-5 fw-bold text-center">Parent Feedback Form</h2>

    <div className="card-body p-0">
      <div className="row g-0">
        {/* Left Side - Video Testimonials */}
        <div className="col-lg-6 bg-light p-4" data-aos="zoom-in-right" data-aos-delay="300" data-aos-durations="1000">
          <h5 className="mb-3 text-purple">
            <i className="bi bi-play-circle me-2"></i>
            What Parents Say About Us
          </h5>
          
          <div className="ratio ratio-16x9 mb-3 rounded overflow-hidden">
            <video autoPlay muted loop playsInline className="w-100">
              <source src="assets/images/testimals_1.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          
          <div className="row g-2">
            {[
              { id: 1, name: "Mrs. Sharma", quote: "Excellent teachers and caring environment" },
              { id: 2, name: "Mr. Patel", quote: "My child has improved tremendously" },
              { id: 3, name: "Mrs. Khan", quote: "Very happy with the curriculum" },
              { id: 4, name: "Mr. Joshi", quote: "Great communication from school" }
            ].map((testimonial) => (
              <div key={testimonial.id} className="col-md-6">
                <div className="p-3 bg-white rounded shadow-sm h-100">
                  <div className="d-flex align-items-center mb-2">
                    <div className="bg-purple bg-opacity-10 text-purple rounded-circle p-2 me-2">
                      <i className="bi bi-person-circle"></i>
                    </div>
                    <strong>{testimonial.name}</strong>
                  </div>
                  <p className="mb-0 small">"{testimonial.quote}"</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Right Side - Feedback Form */}
        <div className="col-lg-6 p-4" data-aos="zoom-in-left" data-aos-delay="300" data-aos-durations="1000">
            <h3 className="mb-3">Form</h3>
          <form>
            <div className="mb-3">
              <label htmlFor="parentName" className="form-label">Parent Name</label>
              <input type="text" className="form-control" id="parentName" required />
            </div>
            
            <div className="mb-3">
              <label htmlFor="studentName" className="form-label">Student Name & Class</label>
              <input type="text" className="form-control" id="studentName" required />
            </div>
            
            <div className="mb-3">
              <label htmlFor="feedbackType" className="form-label">Feedback Type</label>
              <select className="form-select" id="feedbackType">
                <option>General Feedback</option>
                <option>Academic Concern</option>
                <option>Administrative Suggestion</option>
                <option>Extracurricular Activity</option>
              </select>
            </div>
            
            <div className="mb-3">
              <label htmlFor="feedbackMessage" className="form-label">Your Feedback</label>
              <textarea className="form-control" id="feedbackMessage" rows="4" required></textarea>
            </div>
            
            <div className="mb-3 form-check">
              <input type="checkbox" className="form-check-input" id="followUp" />
              <label className="form-check-label" htmlFor="followUp">
                I'd like to receive a follow-up
              </label>
            </div>
            
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <button type="reset" className="btn btn-outline-secondary me-md-2">
                <i className="bi bi-x-circle me-1"></i> Reset
              </button>
              <button type="submit" className="btn btn-purple">
                <i className="bi bi-send me-1"></i> Submit Feedback
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  
    </section>
    <style jsx>{`
    .bg-purple {
        background-color: #6f42c1;
    }
    .btn-purple {
        background-color: #6f42c1;
        color: white;
        border-color: #6f42c1;
    }
    .btn-purple:hover {
        background-color: #5a32a3;
        border-color: #5a32a3;
    }
    video {
        object-fit: cover;
    }
    `}</style>

      {/* DNET School App Access */}
      <section className="mb-5">
      <h2 className="h2  display-5 fw-bold text-center">DNET School App Access</h2>

  <div className="card shadow-sm border-0 h-100" data-aos="fade-right" data-aos-delay="300" data-aos-durations="1000">
    <div className="card-header bgcolor1 text-white d-flex justify-content-between align-items-center">
      <h2 className="h5 mb-0 d-flex align-items-center">
        <i className="bi bi-phone me-2"></i>
        DNET School App Access
      </h2>
      <span className="badge bg-white text-orange">v2.5.1 Latest</span>
    </div>
    
    <div className="card-body">
      <div className="row align-items-center">
        {/* Left Side - App Features */}
        <div className="col-lg-7 mb-2">
          <h5 className="mb-3 color">Key Features:</h5>

          <div className="row">
            <div className="col-sm-6 mb-3">
              <div className="d-flex align-items-start">
                <div className="bg-orange bg-opacity-10 text-orange rounded-circle p-2 me-3">
                  <i className="bi bi-check2-circle fs-5"></i>
                </div>
                <div>
                  <h6 className="mb-1">Real-time Updates</h6>
                  <p className="small mb-0">Instant attendance notifications and school announcements</p>
                </div>
              </div>
            </div>

            <div className="col-sm-6 mb-3">
              <div className="d-flex align-items-start">
                <div className="bg-orange bg-opacity-10 text-orange rounded-circle p-2 me-3">
                  <i className="bi bi-journal-bookmark fs-5"></i>
                </div>
                <div>
                  <h6 className="mb-1">Homework Tracking</h6>
                  <p className="small mb-0">Daily assignments with submission deadlines</p>
                </div>
              </div>
            </div>

            <div className="col-sm-6 mb-3">
              <div className="d-flex align-items-start">
                <div className="bg-orange bg-opacity-10 text-orange rounded-circle p-2 me-3">
                  <i className="bi bi-calendar-event fs-5"></i>
                </div>
                <div>
                  <h6 className="mb-1">Exam Schedules</h6>
                  <p className="small mb-0">Complete timetable with subject details</p>
                </div>
              </div>
            </div>

            <div className="col-sm-6 mb-3">
              <div className="d-flex align-items-start">
                <div className="bg-orange bg-opacity-10 text-orange rounded-circle p-2 me-3">
                  <i className="bi bi-credit-card fs-5"></i>
                </div>
                <div>
                  <h6 className="mb-1">Fee Payments</h6>
                  <p className="small mb-0">Secure online payment gateway</p>
                </div>
              </div>
            </div>
          </div>

          <div className="alert alert-light mt-3">
            <div className="d-flex align-items-center">
              <i className="bi bi-info-circle-fill text-orange me-2"></i>
              <span className="small">App available for Android 8+ and iOS 12+ devices</span>
            </div>
          </div>
        </div>

        {/* Right Side - QR Code & Download */}
        <div className="col-lg-5">
          <div className="d-flex flex-column align-items-center justify-content-center p-4 border rounded bg-light">
            <div className="text-center mb-3">
              <h6 className="color mb-2">Scan to Download</h6>
              <p className="small text-muted">Use your phone camera to scan the QR code</p>
            </div>

            {/* Dummy QR Code - Replace with your actual QR image */}
            <div className="bg-white p-3 rounded border mb-4 shadow-sm" data-aos="Zoom-in-up	" data-aos-delay="300" data-aos-durations="1000">
              <img
                src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://dnet-school.app/download" 
                alt="School App QR Code"
                className="img-fluid"
                style={{ width: '150px', height: '150px' }}
              />
            </div>

            <div className="text-center">
              <p className="small text-muted mb-3">Or download directly from:</p>
              <div className="d-flex flex-wrap justify-content-center gap-2">
                <a
                  href="#"
                  className=" px-3 py-2 d-flex align-items-center"
                >
                  <img
                      src="assets/images/appstore.png"
                      alt="Download on the App Store"
                      style={{ height: '50px' }}
                    />
                </a>

                <a
                  href="#"
                  className=" btn-sm px-3 py-2 d-flex align-items-center"
                >
                  <img
                    src="assets/images/Gstore.png"
                    alt="Get it on Google Play"
                    style={{ height: '50px' }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <style jsx>{`
    .bg-orange {
      background-color: #fd7e14;
    }
    .text-orange {
      color: #fd7e14;
    }
    .btn-dark:hover {
      background-color: #343a40;
      border-color: #343a40;
    }
    .btn-success:hover {
      background-color: #28a745;
      border-color: #28a745;
    }
  `}</style>
        </section>

      {/* Download Centre */}
      <section className="mb-5">
      <h2 className="h2  display-6 fw-bold text-center">Download Centre</h2>

      <div className="card  border-0">
        <div className="card-header bgcolor1 text-white">
          <h2 className="h5 mb-0"> List of Documents</h2>
          {/* <p className="mb-0 small">Important documents for students and parents</p> */}
        </div>
        <div className="card-body" data-aos="fade-right" data-aos-delay="300" data-aos-durations="1000">
          <div className="row g-3">
            {downloadItems.map((item) => (
              <div className="col-md-4 p-3" key={item.id} data-aos="zoom-in-right" data-aos-delay={`${item.id * 160}`} data-aos-durations="1000">
                <div className="card p-3 h-100 border-dark shadow-none transition-all">
                  <div className="card-body text-center d-flex flex-column">
                    <div className="display-4 text-primary mb-3">
                      <i className={`bi ${item.icon}`}></i>
                    </div>
                    <h5 className="mb-2">{item.title}</h5>
                    <p className="text-muted small mb-3">{item.fileSize}</p>
                    <button className="btn custom-hover mt-auto align-self-center">
                      {item.buttonText} <i className="bi bi-download ms-2"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>


    </div>
    </>
  );
};

export default ParentCorner;